var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.002501 18.002501",
    id: "svg6",
    width: 18.002501,
    height: 18.002501,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 0,14.2525 v 3.75 h 3.75 l 11.06,-11.06 -3.75,-3.75 z m 17.71,-10.21 c 0.39,-0.39 0.39,-1.02 0,-1.41 l -2.34,-2.34 c -0.39,-0.39 -1.02,-0.39 -1.41,0 l -1.83,1.83 3.75,3.75 z",
    id: "path5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pen-icon.8311c74da6edffb453842ff972826f02.svg";